import { render, staticRenderFns } from "./IncorrectAnswer.vue?vue&type=template&id=3b227ed2&"
import script from "./IncorrectAnswer.vue?vue&type=script&lang=js&"
export * from "./IncorrectAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports